// import React, {Component} from 'react';
import PbAjax from 'c-up-pbajax';
import url from 'c-url';
import publicpb from './public.pb';
import profilepb from './get.pb';
import Cache from 'c-cache';

let cache = new Cache({
    prefix: 'uplive'
});
let pbajax = new PbAjax();

class Profile {
    constructor(vuid) {
        // debugger;
        this.promise = this.getData({
            vuid
        });
    }

    getData(data) {
        
        let self = this;
        let businessData = new profilepb.Profile.Get.Request(data);
        let defer = $.Deferred()
        // debugger;
        pbajax.do(
            {
                service: 'service',    
                api: '/profile/get',  
                header: {
                    userToken: cache.getCache('user').userToken
                }
            }, 
            businessData, 
            function(res){
            
                let dataWrap = publicpb.Result.decode(res);
                let data;
                
                if (dataWrap.code == 1) {
                    data = profilepb.Profile.Get.Response.decode(dataWrap.data.value);
                    defer.resolve(data.profile);
                
                } else {

                    if (dataWrap.code == 8192) {
                        global.login('http://' + location.hostname + location.pathname);
                    }
                }

            },
            ()=>{
                defer.reject();
            },
            ()=>{
                defer.reject();
            }
        );

        return defer.promise();
    }
}

export default Profile;



// WEBPACK FOOTER //
// ./js/profile/get.js